import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import './style/ClientStory.css'; // 🌟 استدعاء ملف الـ CSS العادي

gsap.registerPlugin(ScrollTrigger);

const storySteps = [
    {
        title: "1. اللقاء الأول وعصف الأفكار",
        description: "يبدأ كل شيء بجلسة استماع عميقة. نجلس مع العميل لنفهم رؤيته، أهدافه، والتحديات التي تواجه مشروعه، وتحويل الأفكار المشتتة إلى خريطة طريق تقنية واضحة.",
        visual: "🤝",
    },
    {
        title: "2. الهندسة والتخطيط المعماري",
        description: "هنا نرسم القواعد الرقمية. نقوم بتصميم بنية قاعدة البيانات، واختيار التقنيات الأنسب (مثل واجهات React السريعة مع قوة نظام حماية وأمان Django)، لضمان نظام مرن وقابل للتوسع المستقبلي.",
        visual: "📐",
    },
    {
        title: "3. مرحلة البناء والتطوير السريع",
        description: "تتحول الأسطر البرمجية إلى واقع ملموس. نعتمد على أسلوب التطوير الرشيق (Agile)، حيث يرى العميل تحديثات حية ومستمرة للمشروع خطوة بخطوة، مع تحسينات مستمرة للأداء والـ SEO التقني منذ اليوم الأول.",
        visual: "💻",
    },
    {
        title: "4. الإنطلاق، الدعم، والنمو سويّاً",
        description: "الإنطلاق ليس النهاية بل البداية. نطلق المنصة برؤية تسويقية وتقنية متكاملة، ونستمر في تتبع الأداء، توفير الدعم اللوجستي، وضمان صعود المؤشرات وتحقيق عوائد حقيقية للعميل.",
        visual: "🚀",
    }
];

const ClientStory = () => {
    const containerRef = useRef(null);

    useGSAP(() => {
        const steps = gsap.utils.toArray('.story-step');
        const visuals = gsap.utils.toArray('.visual-card');

        steps.forEach((step, index) => {
            ScrollTrigger.create({
                trigger: step,
                start: "top center-=100",
                end: "bottom center",
                onEnter: () => {
                    gsap.to(visuals, { opacity: 0, scale: 0.9, duration: 0.4, overwrite: "auto" });
                    gsap.to(visuals[index], { opacity: 1, scale: 1, duration: 0.4, overwrite: "auto" });
                },
                onEnterBack: () => {
                    gsap.to(visuals, { opacity: 0, scale: 0.9, duration: 0.4, overwrite: "auto" });
                    gsap.to(visuals[index], { opacity: 1, scale: 1, duration: 0.4, overwrite: "auto" });
                }
            });
        });
    }, { scope: containerRef });

    return (
        <div ref={containerRef} className="story-container">
            <div className="story-header">
                <h2 className="story-title">كيف نصنع النجاح مع عملائنا؟</h2>
                <p className="story-subtitle">
                    رحلتنا البرمجية والتنفيذية مع كل شريك نجاح خطوة بخطوة، من الفكرة المجردة وحتى الريادة في السوق.
                </p>
            </div>

            <div className="story-grid">
                
                {/* 📌 الجانب الثابت (يظهر في الكمبيوتر فقط) */}
                <div className="story-left">
                    {storySteps.map((step, index) => (
                        <div
                            key={index}
                            className={`visual-card card-${index}`}
                            style={{ 
                                opacity: index === 0 ? 1 : 0, 
                                transform: index === 0 ? 'scale(1)' : 'scale(0.9)' 
                            }}
                        >
                            <span className="visual-icon">{step.visual}</span>
                            <span className="visual-label">
                                {step.title.split('. ')[1]}
                            </span>
                        </div>
                    ))}
                </div>

                {/* 📜 الجانب الذي يتحرك مع الـ Scroll */}
                <div className="story-right">
                    {storySteps.map((step, index) => (
                        <div key={index} className="story-step">
                            {/* أيقونة تظهر في الموبايل فقط فوق الكرت */}
                            <div className={`mobile-icon card-${index}`}>
                                {step.visual}
                            </div>
                            <h3 className="step-title">{step.title}</h3>
                            <p className="step-desc">{step.description}</p>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default ClientStory;